var _rect, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFitting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.875,
    y: 0.875,
    width: 56.0001,
    height: 56,
    rx: 28,
    stroke: "url(#paint0_linear_10132_136182)",
    strokeWidth: 1.75,
    strokeLinecap: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.7052 20.2242V22.1982H34.493L34.5414 25.3133C35.8553 24.6028 37.3584 24.29 38.8638 24.432C40.7856 24.6136 42.5665 25.5214 43.8431 26.9693C45.1197 28.4172 45.7969 30.2969 45.7364 32.2263C45.6758 34.1556 44.8819 35.9891 43.5171 37.3541L42.9796 36.8166C40.3122 39.4838 35.9885 39.4856 33.3212 36.8182C31.9254 35.4223 31.2595 33.5722 31.3246 31.7437C29.8853 31.0596 28.2009 31.0594 26.7617 31.7437C26.8268 33.5723 26.1611 35.4223 24.7651 36.8182C22.0977 39.4854 17.774 39.4855 15.1067 36.8182L14.5708 37.3541C13.2059 35.9891 12.4121 34.1557 12.3515 32.2263C12.291 30.2971 12.9668 28.4171 14.2432 26.9693C15.5198 25.5214 17.3007 24.6136 19.2225 24.432C20.7119 24.2913 22.199 24.5964 23.5029 25.2907V22.1982H15.3827V20.2242H42.7052ZM23.6918 28.2331C21.6171 26.1587 18.2546 26.1586 16.18 28.2331C14.1057 30.3077 14.1057 33.6703 16.18 35.7449C18.2546 37.8195 21.6171 37.8193 23.6918 35.7449C25.7664 33.6702 25.7664 30.3078 23.6918 28.2331ZM41.9063 28.2331C39.8316 26.1587 36.4691 26.1585 34.3945 28.2331C32.3201 30.3077 32.3201 33.6703 34.3945 35.7449C36.4691 37.8195 39.8316 37.8193 41.9063 35.7449C43.9809 33.6702 43.9809 30.3078 41.9063 28.2331ZM25.4769 27.9991C25.9644 28.6752 26.314 29.4191 26.5244 30.1942C28.1388 29.5546 29.9458 29.5549 31.5602 30.1942C31.7703 29.4202 32.121 28.6775 32.6078 28.0023L32.519 22.1982H25.4769V27.9991Z",
    fill: "url(#paint1_linear_10132_136182)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10132_136182",
    x1: 28.875,
    y1: 0.875,
    x2: 28.875,
    y2: 56.875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#786CFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76AFF1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10132_136182",
    x1: 29.0439,
    y1: 20.2242,
    x2: 29.0439,
    y2: 38.8187,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#786CFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76AFF1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFitting);
export default __webpack_public_path__ + "static/media/fitting.241f5782394e5c50ba812baa436371ff.svg";
export { ForwardRef as ReactComponent };